import useHasAccessForTierDeterminator from 'dashboard/apps/VerificationTemplateEditor/hooks/useHasAccessForTierDeterminator';
import useIsVTEInternal from 'dashboard/apps/VerificationTemplateEditor/hooks/useIsVTEInternal';
import { ProductFeatureName } from 'dashboard/models/organization';
import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';

export enum EditorAccessTier {
  Any = 'any',
  VerificationsFree = ProductFeatureName.VerificationsFree,
  VerificationsBasic = ProductFeatureName.VerificationsBasic,
  VerificationsEnhanced = ProductFeatureName.VerificationsEnhanced,
}

export type EditableOptions = {
  accessTier?: EditorAccessTier;
  internalOnly?: boolean;
};

/**
 * @name `useIsEditableWithOptions`
 *
 * A hook that returns whether the component/section of Verification Editor in
 * which it's used is editable, given the options it's passed.
 *
 */
export default (options: EditableOptions = {}): boolean => {
  const { accessTier = EditorAccessTier.Any, internalOnly } = options;

  const isVTEInternal = useIsVTEInternal();

  const hasWritePermissions =
    usePermission(Permission.VerificationTemplateWrite, { global: true }) || false;
  const hasAccessForEffectiveTier = useHasAccessForTierDeterminator()(accessTier);

  if (internalOnly) {
    return isVTEInternal;
  }

  return hasAccessForEffectiveTier && hasWritePermissions;
};
